module.exports = __webpack_public_path__ + "static/media/css.32ff400a.svg";